"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = void 0;

var _react = _interopRequireDefault(require("react"));

var _basis = require("basis");

var _DevAutoFill = require("../../__dev/DevAutoFill");

// @ts-ignore
var Form = function Form(props) {
  var id = props.id,
      initialValues = props.initialValues,
      onSubmit = props.onSubmit,
      children = props.children,
      debug = props.debug;
  return /*#__PURE__*/_react.default.createElement(_basis.Form, {
    initialValues: initialValues,
    onSubmit: onSubmit,
    debug: debug
  }, function (formData) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        position: 'relative'
      }
    }, /*#__PURE__*/_react.default.createElement(_DevAutoFill.DevAutoFill, {
      id: id,
      setFormValues: formData.setValues
    }), typeof children === 'function' ? children(formData) : children);
  });
};

exports.Form = Form;